import React, { useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import "./WithDriverRental.css";

const carData = {
  SUV: [
    {
      name: "Mahindra Scorpio",
      fuels: ["Diesel"],
      image: "https://images.unsplash.com/photo-1606664515524-ed2f786a0bd6",
    },
    {
      name: "Tata Safari",
      fuels: ["Diesel"],
      image: "https://images.unsplash.com/photo-1621007947382-bb3c3994e3fb",
    },
    {
      name: "Hyundai Creta",
      fuels: ["Petrol", "Diesel"],
      image: "https://images.unsplash.com/photo-1619767886558-efdc259cde1a",
    },
  ],
  Sedan: [
    {
      name: "Tata Indigo",
      fuels: ["Petrol", "Diesel", "CNG"],
      image: "https://images.unsplash.com/photo-1580273916550-e323be2ae537",
    },
    {
      name: "Honda City",
      fuels: ["Petrol"],
      image: "https://images.unsplash.com/photo-1552519507-da3b142c6e3d",
    },
  ],
  Hatchback: [
    {
      name: "Maruti Swift",
      fuels: ["Petrol", "CNG"],
      image: "https://images.unsplash.com/photo-1549924231-f129b911e442",
    },
    {
      name: "Hyundai i20",
      fuels: ["Petrol"],
      image: "https://images.unsplash.com/photo-1605559424843-9e4c228bf1c2",
    },
  ],
};

const generateAllCards = () => {
  let cards = [];
  let id = 0;

  Object.keys(carData).forEach((type) => {
    carData[type].forEach((model) => {
      model.fuels.forEach((fuel) => {
        ["AC", "Non-AC"].forEach((acType) => {
          cards.push({
            id: id++,
            name: model.name,
            type,
            fuel,
            image: model.image, // ✅ dynamic image
            ac: acType,
            price: acType === "AC" ? 1200 : 900,
            distance: ["0-50km", "51-100km", "101-200km"][
              Math.floor(Math.random() * 3)
            ],
            rating: (4 + Math.random()).toFixed(1),
          });
        });
      });
    });
  });

  return cards;
};

const WithDriverRental = () => {
  const location = useLocation();
  const navigate = useNavigate();

  let tripData = location.state;
  if (!tripData) {
    const saved = localStorage.getItem("tripData");
    tripData = saved ? JSON.parse(saved) : null;
  }

  const [distance, setDistance] = useState("");
  const [priceSort, setPriceSort] = useState("");

  const [carType, setCarType] = useState("");
  const [carModel, setCarModel] = useState("");
  const [fuelType, setFuelType] = useState("");

  const models = carType ? carData[carType] : [];
  const selectedModel = models.find((m) => m.name === carModel);
  const fuels = selectedModel?.fuels || [];

  let cards = [];

  if (carType && carModel && fuelType) {
    cards = [
      {
        id: 1,
        name: carModel,
        type: carType,
        fuel: fuelType,
        image: selectedModel?.image, // ✅ dynamic image
        ac: "AC",
        price: 1200,
        distance: distance || "0-50km",
        rating: 4.5,
      },
      {
        id: 2,
        name: carModel,
        type: carType,
        fuel: fuelType,
        image: selectedModel?.image, // ✅ dynamic image
        ac: "Non-AC",
        price: 900,
        distance: distance || "0-50km",
        rating: 4.2,
      },
    ];
  } else {
    cards = generateAllCards();
  }

  let filteredCards = cards.filter((c) => !distance || c.distance === distance);

  if (priceSort === "low-high") {
    filteredCards.sort((a, b) => a.price - b.price);
  } else if (priceSort === "high-low") {
    filteredCards.sort((a, b) => b.price - a.price);
  }

  const handleSelectCab = (car) => {
    const bookingData = {
      carData: car,
      pickup: tripData?.pickup,
      drop: tripData?.drop,
      bookingDate: tripData?.date,
      bookingTime: tripData?.time,
    };

    localStorage.setItem("bookingData", JSON.stringify(bookingData));

    navigate("/rental-detail-page-with-driver", {
      state: bookingData,
    });
  };

  return (
    <div className="container">
      <h2>Book Your Cab</h2>

      <div className="dropdowns">
        <select onChange={(e) => setDistance(e.target.value)}>
          <option value="">Distance</option>
          <option>0-50km</option>
          <option>51-100km</option>
          <option>101-200km</option>
          <option>201-300km</option>
        </select>

        <select onChange={(e) => setPriceSort(e.target.value)}>
          <option value="">Price</option>
          <option value="low-high">Low → High</option>
          <option value="high-low">High → Low</option>
        </select>

        <select
          value={carType}
          onChange={(e) => {
            setCarType(e.target.value);
            setCarModel("");
            setFuelType("");
          }}
        >
          <option value="">Car Type</option>
          {Object.keys(carData).map((type) => (
            <option key={type}>{type}</option>
          ))}
        </select>

        <select
          value={carModel}
          onChange={(e) => {
            setCarModel(e.target.value);
            setFuelType("");
          }}
          disabled={!carType}
        >
          <option value="">Car Model</option>
          {models.map((m) => (
            <option key={m.name}>{m.name}</option>
          ))}
        </select>

        <select
          value={fuelType}
          onChange={(e) => setFuelType(e.target.value)}
          disabled={!carModel}
        >
          <option value="">Fuel Type</option>
          {fuels.map((f) => (
            <option key={f}>{f}</option>
          ))}
        </select>
      </div>

      <div className="card-container">
        {filteredCards.map((car) => (
          <div className="car-card" key={car.id}>
            <div className="card-image">
              <img src={car.image} alt="car" /> {/* ✅ dynamic */}
              <span className="fuel-tag">{car.fuel}</span>
            </div>

            <div className="card-content">
              <h2 className="car-title">{car.name.toUpperCase()}</h2>
              <p className="car-sub">{car.type} • 7 Seater</p>

              <div className="price-row">
                <div>
                  <span className="old-price">₹4500</span>
                  <h3 className="new-price">
                    ₹{car.price}
                    <span>/day</span>
                  </h3>
                </div>

                <button
                  className="view-btn"
                  onClick={() => handleSelectCab(car)}
                >
                  VIEW MORE
                </button>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default WithDriverRental;
